import { render, staticRenderFns } from "./BulkOrderContainer.vue?vue&type=template&id=71b33bf0&"
import script from "./BulkOrderContainer.vue?vue&type=script&lang=js&"
export * from "./BulkOrderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports